export default "__VITE_ASSET__7bf803c8__"